// Func = limiting Scope for this file
(function () {
	
	

	function resizeWindow() {
		setTimeout(function () {
			equalize();
			if ($(document).width() < 1200) {
				$("#primary-nav").appendTo(".listHamburgerMenu .containerItemsHamburgerMenu");
			} else {
				$("#primary-nav").appendTo("#header .containerHeader");
			}
		}, 500);
	}
	function scrollDown() {
		let top = $(document).scrollTop();
		if (top > 0) {

		} else {

		}
	}

	function checkReplaceBooking() {
		if ($('.ot-time-picker').length && $('.ot-button').length && $('.ot-party-size-picker select option').length && $('.ot-party-size-picker a').length) {
			$('.ot-button').val('RESERVE A TABLE');
			$('.ot-party-size-picker a').html($('.ot-party-size-picker a').html().replace(/person|people/i, ''));
			$('.ot-party-size-picker select option').each(function () {
				$(this).html($(this).html().replace(/person|people/i, ''));
			});
			$('.ot-time-picker select option').each(function () {
				$(this).html($(this).html().toLowerCase());
			});
			$('#reserveTable').css('display', 'block');
		} else {
			setTimeout(checkReplaceBooking, 250);
		}
	}

	$(document).ready(function () {

		

		$("#meetTheChefLink").fancybox({
			transitionIn: 'fade',
			transitionOut: 'fade',
			openSpeed: 300
		});

		$("#lightbox_menu_a").fancybox().trigger('click');

		$('.hamburgerMenu').on('click', function () {
			$('.listHamburgerMenu').css('left', 0);
		});

		checkReplaceBooking();

		$(".checkmark").insertAfter($('.gdpr input'));

		equalize();
		$('.sym-slides').slick();

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

		//Acts when scroll down page.
		/*$(window).scroll(function (event) {
			scrollDown();
			let scroll = $(window).scrollTop();
			if (scroll >= 100) {
				$("header").css("box-shadow", "none");
			} else {
				$("header").css("box-shadow", "0px -15px 70px 0px #000");
			}
		});*/

		//Wrap elements gallery in home
		$("#gallery .linkImageGallery:eq(1), #gallery .linkImageGallery:eq(2)")
			.wrapAll("<div class='new' />");

		// Main Nav Dropdown
		$("#primary-nav li").hover(function () {
			$(this).addClass("hover");
			$('ul.submenu', this).fadeIn(200);
		}, function () {
			$(this).removeClass("hover");
			$('ul.submenu', this).fadeOut(200);
		});


		$('.book-now').on('click', function () {
			if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
		});
		//this class should be add to the header widget submit button
		$('.bookNow').on('click', function () {
			if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
		});

		//Check in and check out datepicker for booking engine
		$("#CheckIn").datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 1,
			minDate: 0,
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$("#CheckOut").datepicker("setDate", newDate);
				$("#CheckOut").datepicker("option", "minDate", selectedDate);
			}
		});
		$("#CheckOut").datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 1,
			onSelect: function (selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		if ($('#home').length > 0) {
			$('.logoHeader').on('click', function (event) {
				event.preventDefault();
				var heightHeader = $('#header').height() + 50;
				$('html,body').animate({ scrollTop: $('.top-content').offset().top - heightHeader }, 1000);
				$('.listHamburgerMenu').css('left', '100%');
			})
		}
		if ($('#home, #default, .travel-information').length < 1) {
			$('.hamburgerMenu, #primary-nav').remove();
		}
		if ($('#home').length < 1){
			var URLactual = window.location.origin;
			$('#primary-nav ul li a[href*=\\#]').on('click', function (event) {
				event.preventDefault();
				window.location.replace(URLactual + $(this.hash).selector);
			});
		} else {
			$('#primary-nav ul li a[href*=\\#]').on('click', function (event) {
				event.preventDefault();
				$('#primary-nav ul li a').removeClass('active');
				var heightHeader = $('#header').height() + 50;
				var heightSection = heightHeader;

				switch ($(this.hash).selector) {
					case "#gallery":
						heightSection = 95;
						break;
					case "#specials":
						heightSection = 180;
						break;
				}

				$('html,body').animate({ scrollTop: $(this.hash).offset().top - heightSection }, 1000);
				$(this).addClass('active');
				$('.listHamburgerMenu').css('left', '100%');
			});
		}
		$('.menuClose').on('click', function () {
			$('.listHamburgerMenu').css('left', '100%');
		})
	});

	//$('.primary-nav-8 a').replaceWith('<p>(707) 942-4969</p>')

	$(window).load(function () {
	});
	function navisEmailSignup(formID) {

		$.post(site_url + 'ajax/emailsignup.php', $("#" + formID).serialize(), function (data) {
			if (data.error) {
				if (formID == 'email-signup2') {
					$("#email-error2").html(data.msg);
				} else {
					$("#email-error").html(data.msg);
				}


			} else {
				//ga('send', 'event', 'form', 'click', 'specials');
				$("#" + formID).html('<p>Thank You</p>');

			}
		}, 'json');

	}

}());